import { createFileRoute } from '@tanstack/react-router';
import { EnterpriseScopeCounterDiscriminator } from '@mews-commander/data-access';
import { GeneralCountersTable } from '@mews-commander/modules/src/modules/counters';
import { MewsTeam, RouteType } from '@mews/enums';
import { TextKey } from '@mews-commander/enums';

export const Route = createFileRoute('/_authenticated/$currentEnterpriseId/Settings/Counters/Preview')({
    component: () => <GeneralCountersTable counterTypes={[EnterpriseScopeCounterDiscriminator.BillPreviewCounter]} />,
    staticData: {
        title: TextKey.PreviewCounterPlural,
        owner: MewsTeam.Billing,
        type: RouteType.Frontend,
        excludeBreadcrumb: true,
    },
});
